<p-toast key="common" 
    [showTransformOptions]="'translateY(100%)'" 
    [showTransformOptions]="'translateX(100%)'"
    [showTransitionOptions]="'250ms'" 
    [hideTransitionOptions]="'250ms'" 
    [baseZIndex]="5000"
    [breakpoints]="{'920px': {width: '100%', right: '0', left: '0'}}" 
    >
    <ng-template let-message pTemplate="message">
            <span class="p-toast-message-icon mr-2" aria-hidden="true">
                <i class="pi pi-{{ message.data?.icon ?? 'info-circle'}} text-xl"></i>
            </span>
            <div class="p-toast-message-text" (click)="navigateToLink(message.data.link)" [class.cursor-pointer]="message.data?.link">
                <div class="p-toast-summary">{{ message.summary }}
                <!-- @if(message.data?.link){
                    <span class="text-primary"> - Open In New Tab</span>
                } -->
                </div>
                <div class="p-toast-detail">{{ message.detail }}</div>
            </div>
    </ng-template>
</p-toast>